import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { selectDayRange, selectClickedDayTimeBlock } from "../redux/selectors";

class TimeblockView extends React.Component {
    render() {
        const newStartDate = moment(this.props.dayRange.start)
            .add(this.props.index, "days")
            .format("ddd Do MMM");
        const selectedTime = this.props.clickedDayTimeblock;
        let selected = newStartDate === selectedTime ? "-selected" : "";

        if (
            this.props.agendaItemPosition.index === this.props.index &&
            this.props.agendaItemPosition.row === this.props.row - 1 &&
            this.props.agendaItemPosition.parentTrackIndex ===
                this.props.parentTrackIndex &&
            this.props.agendaItemPosition.childTrackIndex ===
                this.props.childTrackIndex
        ) {
            selected = "-hovering";
        }
        const style = {
            gridColumnStart: this.props.column,
            gridColumnEnd: this.props.column,
            gridRowStart: this.props.row,
            gridRowEnd: this.props.row
        };
        return (
            <div
                onDragOver={e => {
                    this.props.setEventPosition(
                        this.props.index,
                        this.props.id
                    );
                    // this.forceUpdate();
                }}
                className={`TimeblockView${selected}`}
                style={style}
            />
        );
    }
}

export default connect(
    store => {
        return {
            dayRange: selectDayRange(store),
            clickedDayTimeblock: selectClickedDayTimeBlock(store)
        };
    },
    {}
)(TimeblockView);
